var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-multi-value');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityValue } from './entity-value';
export var EntityMultiValueDefaultProps = {
  imageSize: 24,
  variant: "smallName",
  wrap: false
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    background-color: ", ";\n    border-radius: 50px;\n    padding: 6px 20px 6px 9px;\n\n    ", "\n  "], ["\n    border: 1px solid ", ";\n    background-color: ", ";\n    border-radius: 50px;\n    padding: 6px 20px 6px 9px;\n\n    ", "\n  "])), theme.COLOR('line-mid'), theme.BG('app-chrome'), function (props) {
    return props.imageStyle === 'banner' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-left: 15px;\n    "], ["\n      padding-left: 15px;\n    "])));
  })
}); // -------- Components -------->

var My = {
  Container: styled(EntityValue)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityMultiValue = function EntityMultiValue(props) {
  var className = props.className,
      rest = __rest(props, ["className"]);

  return React.createElement(My.Container, __assign({}, rest, {
    className: cls.name(className)
  }));
};
EntityMultiValue.defaultProps = EntityMultiValueDefaultProps;
EntityMultiValue.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;